module.exports = __webpack_public_path__ + "img/12_66.37d821df.png";